import React from 'react';
import { Message } from '../types/Message';
import { CitationDisplay, CitationSummary } from './CitationDisplay';
import MarkdownRenderer from './MarkdownRenderer';
import './MarkdownRenderer.css';

// このコンポーネントが受け取るプロパティの型定義
interface MessageListProps {
  messages: Message[];     // 表示するメッセージの配列
  showCitations?: boolean; // 引用情報を表示するかどうか
}

const MessageList: React.FC<MessageListProps> = ({ 
  messages, 
  showCitations = false 
}) => {
  return (
    <div className="message-list">
      {messages.map((message) => (
        <div 
          key={message.id} 
          className={`message ${message.sender === 'user' ? 'user-message' : 'assistant-message'}`}
        >
          <div className="message-content">
            {message.sender === 'assistant' ? (
              <MarkdownRenderer content={message.content} />
            ) : (
              <div className="user-message-text">{message.content}</div>
            )}
          </div>
          
          {/* 引用情報の表示（アシスタントメッセージのみ） */}
          {showCitations && 
           message.sender === 'assistant' && 
           message.metadata?.citations && 
           message.metadata.citations.length > 0 && (
            <div className="message-citations">
              <CitationDisplay citations={message.metadata.citations} />
            </div>
          )}
          
          {/* 簡易引用サマリー（引用があるが詳細表示しない場合） */}
          {!showCitations && 
           message.sender === 'assistant' && 
           message.metadata?.citations && 
           message.metadata.citations.length > 0 && (
            <CitationSummary citations={message.metadata.citations} />
          )}
          
          <div className="message-footer">
            <div className="message-timestamp">
              {message.timestamp.toLocaleTimeString()}
            </div>
            
            {/* Knowledge Base情報の表示（デバッグ用） */}
            {message.metadata?.sessionId && (
              <div className="message-metadata">
                <small>
                  Session: {message.metadata.sessionId.substring(0, 8)}...
                  {message.metadata.knowledgeBaseId && (
                    <> | KB: {message.metadata.knowledgeBaseId}</>
                  )}
                </small>
              </div>
            )}
          </div>
        </div>
      ))}
      {messages.length === 0 && (
        <div className="empty-state">
          <div className="empty-state-content">
            <h3>🤖 RAG Chat Application へようこそ！</h3>
            <p>Knowledge Baseから情報を検索して回答します。</p>
            <p>何か質問してみてください！</p>
            <div className="empty-state-examples">
              <h4>質問例:</h4>
              <ul>
                <li>「このプロジェクトの技術スタックは？」</li>
                <li>「AWSのサービスについて教えて」</li>
                <li>「RAGアプリケーションとは？」</li>
              </ul>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default MessageList;
